webpackJsonp([76277878166992],{

/***/ 736:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/giveaway2.987d95d9.jpg";

/***/ }),

/***/ 355:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  line-height: 2;\n  font-size: 1.125rem;\n'], ['\n  line-height: 2;\n  font-size: 1.125rem;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(60);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _PagePost = __webpack_require__(12);
	
	var _PagePost2 = _interopRequireDefault(_PagePost);
	
	var _Paragraph = __webpack_require__(16);
	
	var _Paragraph2 = _interopRequireDefault(_Paragraph);
	
	var _FullWidth = __webpack_require__(8);
	
	var _FullWidth2 = _interopRequireDefault(_FullWidth);
	
	var _Container = __webpack_require__(6);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _PrimaryImage = __webpack_require__(21);
	
	var _PrimaryImage2 = _interopRequireDefault(_PrimaryImage);
	
	var _SuggestedPage = __webpack_require__(17);
	
	var _SuggestedPage2 = _interopRequireDefault(_SuggestedPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	// eslint-disable-next-line import/no-extraneous-dependencies
	
	// eslint-disable-next-line import/no-extraneous-dependencies
	
	
	var Li = _styledComponents2.default.li(_templateObject);
	
	var PageGiveaway = function PageGiveaway() {
	  return _react2.default.createElement(
	    _PagePost2.default,
	    {
	      back: '#freetrip-giveaway',
	      title: '\u8056\u8A95\u65B0\u5E74\u661F\u7D1A\u884C\u7A0B\u5927\u8CDE',
	      introduction: '\u4F60\u7D66\u4E58\u5BA2\u7684\u661F\u7D1A\u884C\u7A0B\uFF0C\u63DB Uber \u9001\u4F60\u7684\u661F\u7D1A\u65C5\u7A0B\u3002'
	    },
	    _react2.default.createElement(
	      _FullWidth2.default,
	      null,
	      _react2.default.createElement(
	        _Container2.default,
	        { padding: '3rem 3rem 1rem' },
	        _react2.default.createElement(_PrimaryImage2.default, { src: __webpack_require__(736) }),
	        _react2.default.createElement(
	          _Paragraph2.default,
	          null,
	          '\u5F9E12\u670811\u65E5\u81F32018\u5E741\u67081\u65E5\u51CC\u6668\uFF0C\u6BCF\u65E5\u5B8C\u6210\u6700\u591A5\u661F\u884C\u7A0B\u7684\u53F8\u6A5F\u5925\u4F34\u5373\u7372\u50F9\u503C HK$8,000 \u7684\u65C5\u884C\u79AE\u5238\uFF01'
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          '\u8056\u8A95\u65B0\u5E74\u661F\u7D1A\u884C\u7A0B\u5927\u8CDE\u5713\u6EFF\u7D50\u675F'
	        ),
	        _react2.default.createElement(
	          _Paragraph2.default,
	          null,
	          '\u611F\u8B1D\u5404\u4F4D\u53F8\u6A5F\u5925\u4F34\u70BA\u4E58\u5BA2\u63D0\u4F9B\u4E86\u7121\u6578\u7684\u4E94\u661F\u884C\u7A0B\uFF01\u6D3B\u52D5\u671F\u9593\u5206\u5225\u670921\u4F4D\u53CA10\u4F4D\u53F8\u6A5F\u5925\u4F34\u69AE\u7372 HK$8,000 \u65C5\u884C\u79AE\u5238\u6216 iPhone X\uFF0C\u6E96\u5099\u8207\u646F\u611B\u6E21\u5047\u6216\u63DB\u90E8\u6700\u65B0\u624B\u6A5F\u3002\u518D\u6B21\u606D\u559C\u5F97\u734E\u8005\uFF01'
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          '\u9664\u5915\u591C iPhone X \u5927\u8CDE'
	        ),
	        _react2.default.createElement(
	          _Paragraph2.default,
	          null,
	          'Y. Chan \u572812\u670831\u65E5\u5B8C\u6210\u4E8639\u500B5\u661F\u884C\u7A0B',
	          _react2.default.createElement('br', null),
	          'W. Chan \u572812\u670831\u65E5\u5B8C\u6210\u4E8637\u500B5\u661F\u884C\u7A0B',
	          _react2.default.createElement('br', null),
	          'H. So \u572812\u670831\u65E5\u5B8C\u6210\u4E8637\u500B5\u661F\u884C\u7A0B',
	          _react2.default.createElement('br', null),
	          'V. Ho \u572812\u670831\u65E5\u5B8C\u6210\u4E8636\u500B5\u661F\u884C\u7A0B',
	          _react2.default.createElement('br', null),
	          'H. Leung \u572812\u670831\u65E5\u5B8C\u6210\u4E8634\u500B5\u661F\u884C\u7A0B',
	          _react2.default.createElement('br', null),
	          'K. Yip \u572812\u670831\u65E5\u5B8C\u6210\u4E8633\u500B5\u661F\u884C\u7A0B',
	          _react2.default.createElement('br', null),
	          'V. Wu \u572812\u670831\u65E5\u5B8C\u6210\u4E8632\u500B5\u661F\u884C\u7A0B'
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          '\u65C5\u884C\u79AE\u5238\u5927\u8CDE'
	        ),
	        _react2.default.createElement(
	          _Paragraph2.default,
	          null,
	          'K. Yuen \u572812\u670831\u65E5\u5B8C\u6210\u4E8632\u500B5\u661F\u884C\u7A0B',
	          _react2.default.createElement('br', null),
	          'F. Lam \u572812\u670830\u65E5\u5B8C\u6210\u4E8628\u500B5\u661F\u884C\u7A0B',
	          _react2.default.createElement('br', null),
	          'S. Tsui \u572812\u670829\u65E5\u5B8C\u6210\u4E8626\u500B5\u661F\u884C\u7A0B',
	          _react2.default.createElement('br', null),
	          'K. So \u572812\u670828\u65E5\u5B8C\u6210\u4E8629\u500B5\u661F\u884C\u7A0B',
	          _react2.default.createElement('br', null),
	          'N. Wong \u572812\u670827\u65E5\u5B8C\u6210\u4E8629\u500B5\u661F\u884C\u7A0B',
	          _react2.default.createElement('br', null),
	          'C. Mok \u572812\u670826\u65E5\u5B8C\u6210\u4E8614\u500B5\u661F\u884C\u7A0B',
	          _react2.default.createElement('br', null),
	          'W. Man \u572812\u670825\u65E5\u5B8C\u6210\u4E8624\u500B5\u661F\u884C\u7A0B',
	          _react2.default.createElement('br', null),
	          'H. So \u572812\u670824\u65E5\u5B8C\u6210\u4E8626\u500B5\u661F\u884C\u7A0B',
	          _react2.default.createElement('br', null),
	          'C. Lam \u572812\u670824\u65E5\u5B8C\u6210\u4E8628\u500B5\u661F\u884C\u7A0B',
	          _react2.default.createElement('br', null),
	          'O. Lau \u572812\u670824\u65E5\u5B8C\u6210\u4E8628\u500B5\u661F\u884C\u7A0B',
	          _react2.default.createElement('br', null),
	          'S. Yeung \u572812\u670824\u65E5\u5B8C\u6210\u4E8632\u500B5\u661F\u884C\u7A0B',
	          _react2.default.createElement('br', null),
	          'K. Lo \u572812\u670823\u65E5\u5B8C\u6210\u4E8619\u500B5\u661F\u884C\u7A0B',
	          _react2.default.createElement('br', null),
	          'Y. Hui \u572812\u670822\u65E5\u5B8C\u6210\u4E8625\u500B5\u661F\u884C\u7A0B',
	          _react2.default.createElement('br', null),
	          'C. Chan \u572812\u670821\u65E5\u5B8C\u6210\u4E8625\u500B5\u661F\u884C\u7A0B',
	          _react2.default.createElement('br', null),
	          'P. Lee \u572812\u670820\u65E5\u5B8C\u6210\u4E8622\u500B5\u661F\u884C\u7A0B',
	          _react2.default.createElement('br', null),
	          'W. Lam \u572812\u670819\u65E5\u5B8C\u6210\u4E8619\u500B5\u661F\u884C\u7A0B',
	          _react2.default.createElement('br', null),
	          'C. Lee \u572812\u670818\u65E5\u5B8C\u6210\u4E8624\u500B5\u661F\u884C\u7A0B',
	          _react2.default.createElement('br', null),
	          'H. Tong \u572812\u670817\u65E5\u5B8C\u6210\u4E8615\u500B5\u661F\u884C\u7A0B',
	          _react2.default.createElement('br', null),
	          'Y. Ng \u572812\u670816\u65E5\u5B8C\u6210\u4E8615\u500B5\u661F\u884C\u7A0B',
	          _react2.default.createElement('br', null),
	          'L. Wan \u572812\u670815\u65E5\u5B8C\u6210\u4E8615\u500B5\u661F\u884C\u7A0B',
	          _react2.default.createElement('br', null),
	          'M. Cheung \u572812\u670814\u65E5\u5B8C\u6210\u4E8611\u500B5\u661F\u884C\u7A0B',
	          _react2.default.createElement('br', null),
	          'S. Kong \u572812\u670813\u65E5\u5B8C\u6210\u4E8610\u500B5\u661F\u884C\u7A0B',
	          _react2.default.createElement('br', null),
	          'W. Lam \u572812\u670812\u65E5\u5B8C\u6210\u4E8612\u500B5\u661F\u884C\u7A0B',
	          _react2.default.createElement('br', null),
	          'J. Lo \u572812\u670811\u65E5\u5B8C\u6210\u4E8611\u500B5\u661F\u884C\u7A0B'
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          '\u8A08\u5283\u8A73\u60C5'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            Li,
	            null,
	            '\u6D3B\u52D5\u7576\u5929\u4E0A\u5348\u56DB\u6642\u81F3\u7FCC\u65E5\u4E0A\u5348\u56DB\u6642\u671F\u9593\u958B\u59CB\u7684\u884C\u7A0B\u3002'
	          ),
	          _react2.default.createElement(
	            Li,
	            null,
	            '\u672C\u6D3B\u52D5\u6700\u7D42\u89E3\u91CB\u548C\u6C7A\u5B9A\u6B0A\u6B78Uber\u6240\u6709\u3002'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          '* ',
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/freetrip-giveaway-terms' },
	            '\u512A\u60E0\u53D7\u689D\u6B3E\u53CA\u7D30\u5247\u7D04\u675F\u3002'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _Container2.default,
	        { padding: '3rem' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          '\u5176\u4ED6\u76F8\u95DC\u6D3B\u52D5'
	        ),
	        _react2.default.createElement(
	          _SuggestedPage2.default,
	          {
	            to: '/longtrip-bonus',
	            bg: __webpack_require__(185)
	          },
	          '\u9060\u7A0B\u63A5\u55AE\u8ECA\u8CC7\u4FDD\u8B49'
	        ),
	        _react2.default.createElement(
	          _SuggestedPage2.default,
	          {
	            to: '/dec-event',
	            bg: __webpack_require__(172)
	          },
	          '\u7279\u5225\u6D3B\u52D5'
	        )
	      )
	    )
	  );
	};
	
	exports.default = PageGiveaway;
	module.exports = exports['default'];

/***/ }),

/***/ 388:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PageGiveaway = __webpack_require__(355);
	
	var _PageGiveaway2 = _interopRequireDefault(_PageGiveaway);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _PageGiveaway2.default;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-freetrip-giveaway-jsx-acb1e6a7db40a0b778ed.js